let items = [
    {
        "title": "faq.categories.studios.title",
        "items": [
            {
                'title': 'faq.categories.studios.items.access.title',
                'description': 'faq.categories.studios.items.access.description',
            },
            {
                'title': 'faq.categories.studios.items.emergency.title',
                'description': 'faq.categories.studios.items.emergency.description',
            },
            {
                'title': 'faq.categories.studios.items.guests.title',
                'description': 'faq.categories.studios.items.guests.description',
            },
            {
                'title': 'faq.categories.studios.items.duration.title',
                'description': 'faq.categories.studios.items.duration.description',
            },
            {
                'title': 'faq.categories.studios.items.equipment.title',
                'description': 'faq.categories.studios.items.equipment.description',
            },
        ]
    },
    {
        "title": "faq.categories.general.title",
        "items": [
            {
                'title': 'faq.categories.general.items.facilities.title',
                'description': 'faq.categories.general.items.facilities.description',
            },
            {
                'title': 'faq.categories.general.items.subscription.title',
                'description': 'faq.categories.general.items.subscription.description',
            },
            {
                'title': 'faq.categories.general.items.rates.title',
                'description': 'faq.categories.general.items.rates.description',
            },
            {
                'title': 'faq.categories.general.items.cancellation.title',
                'description': 'faq.categories.general.items.cancellation.description',
            }
        ]
    },
    {
        "title": "faq.categories.house_rules.title",
        "items": [
            {
                'title': 'faq.categories.house_rules.items.hygiene.title',
                'description': 'faq.categories.house_rules.items.hygiene.description',
            },
            {
                'title': 'faq.categories.house_rules.items.safety.title',
                'description': 'faq.categories.house_rules.items.safety.description',
            }
        ]
    }
];

module.exports = items
